import { Component } from '@opten/compiler/metadata/component';
import { sidebar } from '@opten/sidebar';
import { getSelectorElementFromElement } from '@opten/dom/get-selector-element-from-element/index';
import { Collapse } from '@opten/collapse/initializer';

import { addClass } from '@opten/dom/add-class';
import { parseCssUnit } from '@opten/number/parse-css-unit';
import { getCss } from '@opten/dom/get-css';
import { getStyles } from '@opten/dom/get-styles';

@Component({ className: 'js-sidebar' })
export default class Sidebar {
    private _cacheMarginBottom = 0;
    constructor(private element: HTMLElement) {
        const body = document.getElementsByClassName(
            'js-body'
        )[0] as HTMLElement;
        const header = document.getElementsByClassName(
            'js-header'
        )[0] as HTMLElement;
        const cookieConsent = document.getElementsByClassName(
            'js-cookie-consent'
        )[0] as HTMLElement;

        sidebar(element, {
            bodyElement: body,
            stickyElements: [header],
            breakpoints: {
                // maxWidth: PAD_WIDTH
                maxWidth: 0
            }
        });

        // todo: better way? we just have one panel so we need this 'hack'...
        // we need special events to open the correct collapse
        const sidebarElement = document.getElementById('c-sidebar-panel');

        if (sidebarElement) {

            sidebarElement.addEventListener('show.opten.sidebar', () => {
                const styles = getStyles(document.body); // cache
                const calculatedMarginBottom = parseCssUnit(getCss(document.body, 'margin-bottom', styles));
                if (calculatedMarginBottom > -1) {
                    this._cacheMarginBottom = calculatedMarginBottom;
                    document.body.style.marginBottom = `0`;
                }
            });

            const links = Array.from(
                document.getElementsByClassName(`js-sidebar-item`)
            );

            links.forEach(link => {
                // todo: why listening not on sidebar?
                link.addEventListener('shown.opten.sidebar', () => {
                    const target = getSelectorElementFromElement(
                        link,
                        'data-collapse',
                        false
                    );

                    if (target) {
                        new Collapse(target).show();
                    }
                });
                addClass(link, 'is--shiny'); //add shiny effect once for more glamour (customer wish)
            });

            sidebarElement.addEventListener('hide.opten.sidebar', () => {
                if (this._cacheMarginBottom > 0) {
                    document.body.style.marginBottom = `${this._cacheMarginBottom}px`;
                }
            });

            // close all collapsables
            sidebarElement.addEventListener('hidden.opten.sidebar', () => {

                links.forEach(link => {
                    const target = getSelectorElementFromElement(
                        link,
                        'data-collapse',
                        false
                    );

                    if (target) {
                        new Collapse(target).hide();
                    }
                });
            });
        }
    }
}
